var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 91,
    viewBox: "0 0 43 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-art"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.7409 16.1207C31.6382 15.8747 31.4328 15.7181 31.2479 15.5616C30.0773 14.6894 28.7628 14.0408 27.4073 13.6383L25.6205 13.4594C25.4562 15.0696 25.2919 16.7021 25.4972 18.29C25.5794 19.0056 25.7437 19.7213 26.175 20.258C26.2777 20.3922 26.4009 20.504 26.5447 20.5487C26.6679 20.5711 26.7706 20.5487 26.8938 20.5264C28.6396 20.0791 30.2621 18.9833 31.3917 17.4625C31.6382 17.0823 31.9052 16.568 31.7409 16.1207Z",
    fill: "#F3982C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.8605 10.8876C25.5071 10.8876 26.0312 10.3168 26.0312 9.61282C26.0312 8.9088 25.5071 8.33807 24.8605 8.33807C24.214 8.33807 23.6899 8.9088 23.6899 9.61282C23.6899 10.3168 24.214 10.8876 24.8605 10.8876Z",
    fill: "#F7A430"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M32.8499 9.61281C32.7267 9.25499 32.5624 8.89717 32.2543 8.69589C31.823 8.42753 31.2685 8.60644 30.8372 8.87481C29.913 9.45627 29.2557 10.4179 28.4958 11.223C27.7359 12.0281 26.1545 13.2358 25.6205 13.4594C25.6821 13.8172 29.954 14.6 31.2479 16.0312C32.1106 16.9929 32.3981 18.4465 32.1516 19.766C33.0348 19.028 33.4045 17.798 33.5893 16.6127C33.9179 14.2645 33.6715 11.8268 32.8499 9.61281Z",
    fill: "#FFCC33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M27.3046 3.06018C25.2302 2.34454 22.9916 2.6129 20.835 2.8589C18.5348 3.12727 16.255 3.39564 13.9547 3.68637C12.743 3.82055 11.4901 3.97709 10.34 3.52982C9.18986 3.08254 8.18348 1.87489 8.32725 0.577789C7.93703 1.89726 7.58788 3.32854 7.93703 4.67038C8.42994 6.59367 10.1962 7.73423 12.0652 8.04732C6.88958 14.6894 2.76139 38.7306 19.9724 54.5418C7.58788 38.0597 9.86762 22.8522 10.7918 18.4465C11.2231 16.389 12.0447 14.0185 13.2975 11.9163C15.988 7.39877 20.3627 6.16876 20.3627 6.16876C23.6077 5.20711 26.5652 5.36365 27.777 5.7662C28.9887 6.16875 30.8166 6.92913 31.2479 8.22623L31.3712 8.09205C31.2685 5.69912 29.379 3.77583 27.3046 3.06018Z",
    fill: "#4163AE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "leaf-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M39.0114 46.7816C35.561 42.1299 30.488 39.3791 25.4767 37.1204L22.7246 36.114C24.1828 39.8711 27.2019 42.5548 30.2621 44.8135C33.3223 47.0723 36.5879 49.1074 38.9703 52.2383C41.3528 55.3693 42.6467 59.9315 41.0858 63.6216C43.8995 58.4779 42.4824 51.4332 39.0114 46.7816Z",
    fill: "#CCDB2A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "leaf-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M24.2649 50.8071C25.3945 59.9315 21.2047 70.0624 14.4477 74.5128C18.4321 74.0655 22.2933 71.024 24.4087 66.663C26.5242 62.3021 26.8528 56.7559 25.2302 52.3055",
    fill: "#02B3B1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "leaf-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M24.3266 50.8965C28.0234 61.3404 27.6538 74.155 22.7656 82.944C27.6743 82.0941 31.0426 76.3242 31.3506 70.2413C31.6382 64.1583 27.7564 54.0498 24.2649 50.7847",
    fill: "#00B3DC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "leaf-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M26.2982 50.9189C32.2338 62.8836 35.1708 76.6821 34.6573 90.0109C38.272 84.7331 38.7649 76.9728 36.9987 70.1071C35.2324 63.2414 31.4533 57.1584 27.2019 51.8805",
    fill: "#A274B2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "leaf-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M32.6651 48.0563C30.6523 46.1107 28.3931 44.5675 26.5036 42.443C24.6141 40.3184 23.0943 37.3887 23.2996 34.3249L23.1353 32.0661C21.102 36.606 22.6219 42.4877 25.3124 46.6027C28.0234 50.7176 31.7409 53.6473 34.9448 57.2031C38.1488 60.759 41.0036 65.433 40.9831 70.6215C41.4144 62.1679 38.2104 53.446 32.6651 48.0563Z",
    fill: "#E92D7B"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M24.1006 22.8075C21.7593 22.8746 19.3768 22.1813 17.5695 20.5934C14.9611 25.2228 13.7494 32.7818 14.078 37.9702C14.4066 43.4717 16.8096 49.6218 20.2805 53.6696C17.5079 44.3662 18.5348 30.5006 24.1006 22.8075Z",
    fill: "#6DCDE1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M15.8853 19.7213C14.4887 18.1782 13.6672 16.0983 13.7699 14.0409C11.7982 18.6702 10.7713 23.7244 10.8124 28.7563C10.874 35.9798 13.1332 43.1586 17.1998 49.0851C15.0433 44.2097 13.5029 39.0213 13.2359 33.6987C12.9689 28.9352 13.7699 24.0152 15.8853 19.7213Z",
    fill: "#2BA7DF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M20.8145 6.57132C18.3294 8.5617 16.9739 11.5361 17.3846 14.1527C17.7954 16.7692 19.9314 18.9833 22.8683 19.766C21.0404 20.6829 18.9045 20.012 17.6311 18.8491C13.3386 14.9578 17.6927 8.15916 20.7118 6.59368",
    fill: "#02B3B1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "leaf-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M22.2111 61.8548C21.7798 55.7942 17.9186 52.6856 13.8726 51.1201C11.675 50.2703 9.31309 50.1809 7.01281 49.8007C4.71252 49.4205 2.33009 48.6825 0.707565 46.8934C2.06309 52.462 3.66507 58.4331 7.87541 61.9219C11.1615 64.6503 15.7826 65.3212 19.6028 63.6439C19.8492 63.5321 20.1162 63.3979 20.1984 63.1295C20.26 62.9283 20.2189 62.7046 20.1573 62.5034C19.1715 59.1711 16.2756 56.8677 13.2359 55.7718C15.4746 55.3916 18.658 55.8613 22.1906 61.8548",
    fill: "#3DB54A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M3.60345 51.5451C4.69198 54.43 6.62258 56.89 8.86125 58.791C11.1205 60.7143 13.7083 62.1232 16.3577 63.3085C13.2975 63.7781 10.073 62.7941 7.67003 60.6472C5.28759 58.5002 3.7883 55.2351 3.62399 51.8805",
    fill: "#8BC441"
  })), /*#__PURE__*/React.createElement("g", {
    id: "leaf-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M39.9151 33.0501C37.6148 27.9064 32.7062 23.8362 27.6332 24.5071L26.976 24.9768C29.9951 25.5806 33.6304 26.587 36.6906 34.4591C32.2954 28.063 28.7217 26.1844 25.5383 26.0055L25.2713 26.1844C22.4576 26.8106 21.0199 30.7466 21.8414 33.8329C22.6835 36.9191 25.1481 39.1107 27.7564 40.4526C30.3648 41.7944 33.2196 42.4877 35.869 43.7177C38.5185 44.9701 41.0858 46.9381 42.2154 49.9125C42.4413 44.1873 42.2359 38.1938 39.9151 33.0501Z",
    fill: "#8BC441"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M25.7026 29.4496C24.5936 30.0981 23.8542 31.44 23.8747 32.8042C23.9158 34.2578 24.7989 35.6444 26.0518 36.1587C24.8195 34.2355 24.6962 31.5518 25.7026 29.4496Z",
    fill: "#CCDB2A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.c141f8ca3c7a42e1a491a019f7391936.svg";
export { ForwardRef as ReactComponent };